import styled, {css} from "styled-components"
import {DESKTOP, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"

export const SliderWrapper = styled.div`
  ${({theme}) => css`
    .slick-dots {
      position: absolute;
      bottom: 20px;
      margin: 0;
      list-style: none;
      text-align: center;
      display: flex !important;
      justify-content: flex-end !important;
    }

    .slick-dots button:before {
      color: ${theme.colors.utility.contrast}
    }

    .slick-dots li.slick-active button:before {
      width: 10px;
      height: 10px;
      color: ${theme.colors.utility.white}
    }
  `
}`

export const SliderBannerSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {breakpoint: PHONE_LANDSCAPE, settings: {arrows: false}},
    {breakpoint: TABLET, settings: {slidesToShow: 1, slidesToScroll: 1, arrows: false}}
  ]
}

export const SliderSettings = {
  responsive: [
    {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: TABLET - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: DESKTOP - 1, settings: {slidesToShow: 2, slidesToScroll: 2}}
  ]
}
